import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-sended',
  templateUrl: './reset-password-sended.component.html',
  styleUrls: ['./reset-password-sended.component.css']
})
export class ResetPasswordSendedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
